/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPatientPasswordRequestBodyTypename = "PutPatientPasswordRequestBody" as const;

/**
 *
 * @export
 * @interface PutPatientPasswordRequestBody
 */
export interface PutPatientPasswordRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutPatientPasswordRequestBody
   */
  password: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPatientPasswordRequestBody
   */
  readonly __typename?: string;
}

export function PutPatientPasswordRequestBodyFromJSON(json: any): PutPatientPasswordRequestBody {
  return PutPatientPasswordRequestBodyFromJSONTyped(json, false);
}

export function PutPatientPasswordRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPatientPasswordRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPatientPasswordRequestBodyTypename,

    password: json["password"],
  };
}

export function PutPatientPasswordRequestBodyToJSON(object?: PutPatientPasswordRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    password: value.password,
  };
}
